// src/store/thunks/organizationUsers/createUserThunk.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import type { CreatedUserResponse, PortalUserValues } from '@/types/users.types';
import { withLoader, withErrorHandling } from '@/store/thunks/thunkWrappers';
import { normalizeEmail } from '@/utils/strings/strings';

// Create a new portal user
export const createUserThunk = createAdminAsyncThunk<CreatedUserResponse, PortalUserValues>(
  'organizationUsers/create',
  withLoader(
    withErrorHandling(
      async(dto, { extra: { usersService } }) =>
        await usersService.createUser({ ...dto, email: normalizeEmail(dto.email) })
    )
  )
);
